import React, { useState } from "react";
import { formatPrice } from "../utils/format";

function ProductShow(props) {

    const [cantidad, setCantidad] = useState(
        props.items.find((item) => item.product.id === props.product.id)?.quantity || 0
    );

    function updateCart(next) {
        let cartCopy = [...props.cart];
        let productIndex = cartCopy.findIndex((item) => item.product.id === props.product.id);

        if (next === 0) {
            if (productIndex !== -1) cartCopy.splice(productIndex, 1);
        } else if (productIndex !== -1) {
            cartCopy[productIndex].quantity = next;
            cartCopy[productIndex].total = props.product.currentPrice * next;
        } else {
            cartCopy.push({
                product: props.product,
                quantity: next,
                total: props.product.currentPrice * next,
            });
        }

        props.setCart(cartCopy);
        props.setItems(cartCopy);
    }

    function handleSum(event) {
        event.preventDefault();
        if (cantidad < 20) {
            const next = cantidad + 1;
            setCantidad(next);
            updateCart(next);
        }
    }

    function handleRes(event) {
        event.preventDefault();
        if (cantidad > 0) {
            const next = cantidad - 1;
            setCantidad(next);
            updateCart(next);
        }
    }

    const isInCart = cantidad > 0;
    const hasDiscount = props.product.originalPrice > props.product.currentPrice;
    const discountPct = hasDiscount
        ? Math.round((1 - props.product.currentPrice / props.product.originalPrice) * 100)
        : 0;

    return (
        <div
            className={`
                relative flex flex-col bg-white overflow-hidden
                transition-all duration-200
                w-[168px] min-w-[168px] h-[280px]
                lg:w-full lg:min-w-0 lg:h-[380px]
                lg:hover:-translate-y-0.5 lg:hover:shadow-md
                ${isInCart
                    ? "rounded-2xl ring-2 ring-[#4a7c2f] shadow-lg shadow-[#2f5a2e]/10"
                    : "rounded-2xl border border-gray-100 shadow-sm"
                }
            `}
            style={{ overflow: "hidden" }}
        >
            {/* Badge cantidad en carrito */}
            {isInCart && (
                <div className="absolute top-2 right-2 z-10 bg-[#2f5a2e] text-[#cde29a] text-[10px] lg:text-[11px] font-bold rounded-full w-5 h-5 lg:w-6 lg:h-6 flex items-center justify-center shadow">
                    {cantidad}
                </div>
            )}

            {/* Badge descuento — esquina superior izquierda */}
            {hasDiscount && (
                <div className="absolute top-2 left-2 z-10 bg-[#1e2a1a] text-[#f4f3e6] text-[9px] lg:text-[10px] font-bold px-1.5 lg:px-2 py-0.5 rounded-md shadow">
                    -{discountPct}%
                </div>
            )}

            {/* Imagen — al tocarla suma 1 al carro, igual que el "+" */}
            <div
                role="button"
                aria-label={`Agregar ${props.product.name} al carro`}
                onClick={handleSum}
                className="w-full bg-white border-b border-gray-50 flex-shrink-0 h-[140px] lg:h-[230px] cursor-pointer select-none active:opacity-80 transition-opacity"
                style={{ overflow: "hidden", WebkitTapHighlightColor: "transparent" }}
            >
                {props.product.imageUrl ? (
                    <img
                        src={props.product.imageUrl}
                        alt={props.product.name}
                        draggable={false}
                        className="w-full h-[140px] lg:h-[230px] block"
                        style={{
                            objectFit: "contain",
                            objectPosition: "center",
                        }}
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-4xl">🥑</div>
                )}
            </div>

            {/* Info — solo texto, con padding lateral */}
            <div className="px-3 pt-2 flex flex-col flex-1 lg:px-4 lg:pt-3">
                <div>
                    {/* Nombre */}
                    <p className="text-[13px] lg:text-[15px] font-semibold text-[#1e2a1a] leading-tight line-clamp-1">
                        {props.product.name}
                    </p>

                    {/* Descripción */}
                    <p className="text-[11px] lg:text-[12px] text-gray-400 leading-tight line-clamp-1 mt-0.5">
                        {props.product.description || "\u00a0"}
                    </p>

                    {/* Precio — espacio fijo reservado siempre para mantener altura uniforme */}
                    <div className="mt-1 min-h-[38px] lg:min-h-[46px]">
                        {hasDiscount ? (
                            <>
                                {/* Precio original tachado */}
                                <p className="text-[10px] lg:text-[12px] text-gray-400 line-through leading-none">
                                    {formatPrice(props.product.originalPrice)} / {props.product.type}
                                </p>
                                {/* Precio actual en oferta */}
                                <p className="text-[12px] lg:text-[15px] text-[#2f5a2e] font-bold leading-tight mt-0.5">
                                    {formatPrice(props.product.currentPrice)} / {props.product.type}
                                </p>
                            </>
                        ) : (
                            <>
                                {/* Placeholder invisible */}
                                <p className="text-[10px] lg:text-[12px] leading-none invisible">&nbsp;</p>
                                {/* Precio normal */}
                                <p className="text-[11px] lg:text-[14px] text-[#4a7c2f] font-semibold leading-tight mt-0.5">
                                    {formatPrice(props.product.currentPrice)} / {props.product.type}
                                </p>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Botón — fuera del padding, pegado al fondo, ancho completo */}
            <div className="px-3 pb-3 lg:px-4 lg:pb-4">
                {cantidad === 0 ? (
                    <button
                        onClick={handleSum}
                        className="w-full py-2 lg:py-2.5 rounded-xl bg-[#2f5a2e] text-[#f4f3e6] text-[12px] lg:text-[14px] font-semibold active:scale-95 transition-transform lg:hover:bg-[#3f7a3a]"
                    >
                        Agregar
                    </button>
                ) : (
                    <div className="flex items-center justify-between bg-[#edf4e0] rounded-xl px-1 py-1 lg:px-1.5 lg:py-1.5">
                        <button
                            onClick={handleRes}
                            className="w-8 h-8 lg:w-9 lg:h-9 rounded-lg bg-white text-[#1e2a1a] text-lg font-medium shadow-sm active:scale-90 transition-transform flex items-center justify-center"
                        >
                            −
                        </button>
                        <span className="text-[11px] lg:text-[13px] font-semibold text-[#1e2a1a]">
                            {cantidad} {cantidad === 1 ? props.product.subName : `${props.product.subName}s`}
                        </span>
                        <button
                            onClick={handleSum}
                            className="w-8 h-8 lg:w-9 lg:h-9 rounded-lg bg-[#2f5a2e] text-[#f4f3e6] text-lg font-medium shadow-sm active:scale-90 transition-transform flex items-center justify-center"
                        >
                            +
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ProductShow;